module.exports = __webpack_public_path__ + "img/coach-4.81445c2c.jpg";